<template>
  <div
    class="footer_container container-fluid d-flex justify-content-center pt-4"
  >
    <footer class="w-100 font-small blue pt-4">
      <div class="container-fluid text-center text-md-left">
        <div class="row">
          <div class="col-12 col-md-3 ">
            <div class="container">
              <div class="row justify-content-start mb-3">
                <div class="col-12">
                  <a href="//www.rtm.gov.my/" target="_blank">
                    <div class="footer_logo">
                      <img
                        src="../assets/rtmklik/rtm_logo.png"
                        alt="rtm logo"
                        class="w-100"
                      />
                    </div>
                  </a>
                </div>
              </div>
              <div class="row justify-content-start">
                <div class="col-12">
                  <div
                    class="w-100 d-flex justify-content-center justify-content-md-start"
                  >
                    <a
                      class="mr-3 mr-lg-4"
                      href="https://www.facebook.com/RadioTelevisyenMalaysia/"
                      role="button"
                      ><img
                        src="../assets/rtmklik/footer_icon_facebook.svg"
                        alt="facebook icon"
                        class="footer_icon"
                    /></a>

                    <a
                      class="mr-3 mr-lg-4"
                      href="https://twitter.com/rtm_malaysia?lang=en"
                      role="button"
                      ><img
                        src="../assets/rtmklik/footer_icon_twitter.svg"
                        alt="twitter icon"
                        class="footer_icon"
                    /></a>

                    <a
                      class="mr-3 mr-lg-4"
                      href="https://www.instagram.com/rtm_malaysia/?hl=en"
                      role="button"
                      ><img
                        src="../assets/rtmklik/footer_icon_insta.svg"
                        alt="instagram icon"
                        class="footer_icon"
                    /></a>

                    <a
                      class="mr-3 mr-lg-4"
                      href="https://www.youtube.com/c/RadioTelevisyenMalaysia"
                      role="button"
                      ><img
                        src="../assets/rtmklik/footer_icon_youtube.svg"
                        alt="youtube icon"
                        class="footer_icon"
                    /></a>

                    <a
                      class=""
                      href="https://www.tiktok.com/@radiotelevisyenmalaysia?lang=en"
                      role="button"
                      ><img
                        src="../assets/rtmklik/footer_icon_tiktok.svg"
                        alt="tiktok icon"
                        class="footer_icon"
                    /></a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-md-2 col-lg-2 mt-3 mt-md-0 mb-0">
            <ul class="list-unstyled">
              <li class="mb-2">
                <router-link :to="'/latar-belakang'" exact class="text-links"
                  >Latar Belakang</router-link
                >
              </li>
              <li class="mb-2">
                <a
                  href="https://www.rtm.gov.my/index.php/jabatan-agensi"
                  class="text-links"
                  target="_blank"
                  >Kementerian Komunikasi</a
                >
              </li>
              <li class="mb-2">
                <router-link :to="'/soalan-lazim/bm'" exact class="text-links"
                  >Soalan Lazim</router-link
                >
              </li>
              <!--  <li class="mb-2">
                <router-link :to="'/'" exact class="text-links"
                  >Maklum Balas</router-link
                >
              </li> -->
            </ul>
          </div>

          <div class="col-12 col-md-2 col-lg-3 mb-0 mb-md-0 ">
            <ul class="list-unstyled">
              <li class="mb-2">
                <router-link :to="'/penafian'" exact class="text-links"
                  >Penafian</router-link
                >
              </li>
              <li class="mb-2">
                <router-link :to="'/dasar-privasi'" exact class="text-links"
                  >Dasar Privasi</router-link
                >
              </li>
              <li class="mb-2">
                <a
                  href="https://rtmklik.rtm.gov.my/Polisi-Keselamatan-Maklumat-dan-Privasi-2023.pdf"
                  target="_blank"
                  class="text-links"
                  >Polisi Keselamatan Maklumat dan Privasi</a
                >
              </li>
            </ul>
          </div>

          <div class="col-12 col-md-5 col-lg-4 mt-3 mt-md-0 mb-md-0 mb-3">
            <div class="container">
              <div
                class="row justify-content-center justify-content-md-start mb-3"
              >
                <div class="col-12 col-md-auto px-0 mb-2 my-md-0 mr-2">
                  <img
                    src="../assets/rtmklik/footer-standard-malaysia-acb-021.png"
                    alt="Cyber Security Logo"
                    class="cert_icon"
                  />
                </div>
                <div
                  class="col-12 col-md-auto px-0 mb-2 my-md-0 d-flex justify-content-center"
                >
                  <div class="d-flex flex-column max-width-cyber">
                    <img
                      src="../assets/rtmklik/footer-cyber-security-27001.png"
                      alt="Cyber Security Logo"
                      class="cert_icon"
                    />
                    <p class="cyber_security_text">
                      Certified to MS ISO/IEC 27001:2013 CERT NO.: 064-IM002
                    </p>
                  </div>
                </div>
                <div
                  class="col-12 col-md-auto px-0 mb-2 my-md-0 d-flex justify-content-center"
                >
                  <div class="d-flex flex-column max-width-cyber">
                    <img
                      src="../assets/rtmklik/footer-cyber-security.png"
                      alt="Cyber Security Logo"
                      class="cert_icon"
                    />
                    <p class="cyber_security_text">
                      Certified to MS ISO/IEC 27701:2019 CERT NO.: 001-IM002
                    </p>
                  </div>
                </div>
              </div>
              <div class="row justify-content-center justify-content-md-start">
                <div class="col-auto px-0 mb-2 my-md-0">
                  <a
                    class=""
                    href="https://apps.apple.com/my/app/rtmklik/id777391399"
                    role="button"
                    target="_blank"
                    ><img
                      src="../assets/rtmklik/batch_iOS.png"
                      alt="footer ios icon"
                      class="apps_icon"
                  /></a>
                </div>
                <div class="col-auto mb-2 my-md-0">
                  <a
                    class=""
                    href="https://play.google.com/store/apps/details?id=my.gov.rtm.mobile"
                    role="button"
                    target="_blank"
                    ><img
                      src="../assets/rtmklik/batch_android.png"
                      alt="footer android icon"
                      class="apps_icon"
                  /></a>
                </div>
                <div class="col-auto px-0 mb-1 my-md-0 ">
                  <a
                    class=""
                    href="https://appgallery.cloud.huawei.com/ag/n/app/C101841473?locale=en_GB&source=appshare&subsource=C101841473&shareTo=com.google.android.gm&shareFrom=appmarket&shareIds=93e730768f4c48c48dadb213265fe98f_com.google.android.gm&callType=SHARE"
                    role="button"
                    target="_blank"
                    ><img
                      src="../assets/rtmklik/batch_huawei.png"
                      alt="huawei footer icon"
                      class="apps_icon"
                  /></a>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-12 pl-0">
                  <div class="copyright text-center text-md-left mt-2">
                    Hak Cipta Terpelihara © {{ new Date().getFullYear() }} RADIO
                    TELEVISYEN MALAYSIA
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
/* eslint-disable */

export default {
  data: function() {
    return {};
  },
  components: {},
  methods: {},
};
</script>

<style scoped>
.footer_container {
  width: 100%;
  padding: 50px 40px;
  background: #000;
  border-top: 1px solid #d9e021;
}
.footer_logo {
  width: 150px;
}
.footer_icon {
  height: 24px;
}
.link-parent-wrapper {
  width: 100%;
  max-width: 80%;
}
.header-text {
  font-size: 14px;
  line-height: 1.14;
  text-align: left;
  color: #fff;
}
.text-links {
  color: #fff;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20.8px;
}
.list-unstyled li {
  text-align: left;
}
.line {
  border-bottom: solid 1px #a8a9ab;
}
.app-wrapper {
  width: 100%;
  max-width: 550px;
  margin: 0 auto;
}
.apps_icon {
  width: 108px;
  height: 32px;
  overflow: hidden;
}
.cert_icon {
  height: 64px;
  max-width: 100%;
  overflow: hidden;
}

.cyber_security_text {
  font-family: Arial;
  font-size: 12px;
  font-weight: 700;
  line-height: 12.07px;
  text-align: center;
  color: #ffffff;
}
.max-width-cyber {
  max-width: 180px;
}
.copyright {
  font-size: 14px;
  font-weight: normal;
  line-height: 1.14;
  color: #fff;
}
@media only screen and (max-width: 1280px) {
  .footer_icon {
    height: 16px;
  }
  .cert_icon {
    height: 56px;
  }
  .max-width-cyber {
    max-width: 156px;
  }
}
@media only screen and (max-width: 767px) {
  .footer_container {
    padding: 16px !important;
  }
  .header-text,
  .text-links,
  .list-unstyled {
    margin-bottom: 0;
  }
  .list-unstyled li {
    text-align: center;
  }

  .footer_logo {
    margin: 0 auto;
  }
  .apps_icon {
    width: 98px;
  }

  .cert_icon {
    height: 66px;
  }
  .max-width-cyber {
    max-width: 190px;
  }
}
</style>
